// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__R1A6a","contactsItem":"footer_contactsItem__soK3E","emailLink":"footer_emailLink__Lp1I4"};